__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-18-1771418746-stable-dev/";